module.exports = "https://static.wmbcdn.com/uniweb/images/23c9763d6ba1f79786094e19a378adac.svg";